import type { 
  GetPlayersData,
  GetPlayersResponse,
  
  GetPlayersCountData,
  GetPlayersCountResponse,

  GetPlayersByIdData,
  GetPlayersByIdResponse,

  GetPlayersByIdCrmLogsData,
  GetPlayersByIdCrmLogsResponse,

  GetPlayersByIdStatsData,
  GetPlayersByIdStatsResponse,

  PostPlayersByIdAttachData,
  PostPlayersByIdAttachResponse,

  PostPlayersByIdDetachData,
  PostPlayersByIdDetachResponse,

  PostPlayersByIdMarkAsVirtualData,
  PostPlayersByIdMarkAsVirtualResponse,

  PostPlayersMassAttachToAffiliateData,
  PostPlayersMassAttachToAffiliateResponse,

  PostPlayersMassDetachFromAffiliateData,
  PostPlayersMassDetachFromAffiliateResponse,

  PostPlayersMassMarkAsVirtualData,
  PostPlayersMassMarkAsVirtualResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getPlayersApiModule(affiliatesApi: AxiosInstance) {
  return {
    getPlayers(params: GetPlayersData['query']) {
      return affiliatesApi.get<GetPlayersResponse>('/players', { params });
    },
    getPlayersCount(params: GetPlayersCountData['query']) {
      return affiliatesApi.get<GetPlayersCountResponse>('/players/count', { params });
    },
    // changePlayersStatus(id, virtual) {
    //   return affiliatesApi.put(`/players/${id}`, {
    //     is_virtual: virtual,
    //   });
    // },
    getPlayerInfo(id: string) {
      return affiliatesApi.get<GetPlayersByIdResponse>(`/players/${id}`);
    },
    getPlayerLogs(id: string, params: GetPlayersByIdCrmLogsData['query']) {
      return affiliatesApi.get<GetPlayersByIdCrmLogsResponse>(`/players/${id}/crm-logs`, { params });
    },
    getPlayerStats(id: string, params: GetPlayersByIdStatsData['query']) {
      return affiliatesApi.get<GetPlayersByIdStatsResponse>(`/players/${id}/stats`, { params });
    },
    attachPlayerAffiliate(id: string, params: PostPlayersByIdAttachData['body']) {
      return affiliatesApi.post<PostPlayersByIdAttachResponse>(`/players/${id}/attach`, params);
    },
    detachPlayerAffiliate(id: string) {
      return affiliatesApi.post<PostPlayersByIdDetachResponse>(`/players/${id}/detach`);
    },
    markAsVirtual(id: string) {
      return affiliatesApi.post<PostPlayersByIdMarkAsVirtualResponse>(`/players/${id}/mark-as-virtual`);
    },
    massAttachPlayerAffiliate(params: PostPlayersMassAttachToAffiliateData['body']) {
      const {
        site_id,
        affiliate_id,
        affiliate_offer_id,
        site_player_ids,
        file_ids,
        overwrite_player_affiliate_attachment,
      } = params;

      return affiliatesApi.post<PostPlayersMassAttachToAffiliateResponse>('/players/mass-attach-to-affiliate', {
        site_id,
        affiliate_id,
        affiliate_offer_id,
        site_player_ids,
        file_ids,
        overwrite_player_affiliate_attachment,
      });
    },
    massDetachPlayerAffiliate(params: PostPlayersMassDetachFromAffiliateData['body']) {
      const {
        site_id,
        site_player_ids,
        file_ids,
        player_attached_to_affiliate_id,
      } = params;

      return affiliatesApi.post<PostPlayersMassDetachFromAffiliateResponse>('/players/mass-detach-from-affiliate', {
        site_id,
        site_player_ids,
        file_ids,
        player_attached_to_affiliate_id,
      });
    },
    massMarkAsVirtual(params: PostPlayersMassMarkAsVirtualData['body']) {
      const {
        site_id,
        site_player_ids,
        file_ids,
      } = params;

      return affiliatesApi.post<PostPlayersMassMarkAsVirtualResponse>('/players/mass-mark-as-virtual', {
        site_id,
        site_player_ids,
        file_ids,
      });
    },
  }
}